/**
* =========================================================================================
* Component - Toggle Switch
* ========================================================================================= 
**/

import React from 'react';

// Packages
import PropTypes from 'prop-types';
import UPopup from "ubs-framework/v2/UPopup";
import * as Icon from '../../../icons'
import { COLOR } from '../common/constant'

const UToggleSwitch = (props) => {
	return (
		<React.Fragment>
			<div className={`u_toggle-switch ${props.isActive <= '01' ? 'disabled' : ''} ${props.disabled ? 'u_disabled' : ''} ${props?.className || ''}`}>
				<input type="checkbox" id={props.id} readOnly disabled={props?.disabled} onChange={(e) => props?.disabled ? null : props.onChange(e)} checked={props.checked} />
				<label htmlFor={props.id} />
				{props.label && <span className={'u_toggle-switch-label'}>{props.label}</span>}
				{props?.note && <div className="u_ib">
                    <UPopup
                        params={{className: "u_tooltip u_tooltip-full", on: ['click', 'hover']}}
                        desc={<span dangerouslySetInnerHTML={{__html: props?.note}}/>}
                    >
                            <span className="u_rollover u_cp u_flex">
                                <Icon.InfoTooltip fill={COLOR.u_icon_bg} size={18}/>
                            </span>
                    </UPopup>
                </div>}
			</div>
		</React.Fragment>
	)
}

UToggleSwitch.propTypes = {
	id: PropTypes.string,
	disabled: PropTypes.bool,
	checked: PropTypes.bool,
	onChange: PropTypes.func,
	label: PropTypes.string,
	className: PropTypes.string,
}

UToggleSwitch.defaultProps = {
    id: "",
	disabled: false,
	checked: false,
	onChange: () => {},
	label: "",
	className: "",
}

export default UToggleSwitch;